import client from './client';
import { Event } from '../types';

interface EventsResponse {
  events: Event[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface FailedUploadItem {
  _id: string;
  filename: string;
  errorCode: 'size_exceeded' | 'invalid_file' | 'quota_exceeded' | 'processing_error';
  errorMessage: string;
  failedAt: string;
}

export interface FaceIndexErrorPhoto {
  _id: string;
  originalFilename: string;
  thumbnailUrl: string | null;
  fileSizeBytes: number;
  uploadedAt: string;
  reason: 'too_large' | 'other';
}

interface FaceIndexErrorsResponse {
  count: number;
  items: FaceIndexErrorPhoto[];
}

interface RetryFaceIndexErrorsResponse {
  message: string;
  total: number;
}

export const eventsApi = {
  list: (page = 1, limit = 20) =>
    client.get<EventsResponse>('/events', { params: { page, limit } }).then((r) => r.data),

  create: (data: { name: string; description?: string }) =>
    client.post<Event>('/events', data).then((r) => r.data),

  get: (id: string) => client.get<Event>(`/events/${id}`).then((r) => r.data),

  update: (id: string, data: { name?: string; description?: string }) =>
    client.patch<Event>(`/events/${id}`, data).then((r) => r.data),

  end: (id: string) => client.post<Event>(`/events/${id}/end`).then((r) => r.data),

  delete: (id: string) =>
    client.delete<{ message: string; photosDeleted: number; ftpAccountsDeleted: number; s3ObjectsDeleted: number }>(
      `/events/${id}`
    ).then((r) => r.data),

  listFaceIndexErrors: (id: string) =>
    client.get<FaceIndexErrorsResponse>(`/events/${id}/face-index/errors`).then((r) => r.data),

  retryFaceIndexErrors: (id: string) =>
    client.post<RetryFaceIndexErrorsResponse>(`/events/${id}/face-index/retry-errors`).then((r) => r.data),

  listUploadErrors: (id: string) =>
    client.get<{ count: number; items: FailedUploadItem[] }>(`/events/${id}/upload-errors`).then((r) => r.data),
};
